"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PracticeCompetitionStatus = exports.PracticeCreationType = exports.PracticeType = exports.PracticeStatus = void 0;
/**
 * Status for how far in the practice progress for {@link PracticeLog} the entry has come
 */
var PracticeStatus;
(function (PracticeStatus) {
    PracticeStatus[PracticeStatus["RUNNING"] = 0] = "RUNNING";
    PracticeStatus[PracticeStatus["EXITED"] = 1] = "EXITED";
})(PracticeStatus = exports.PracticeStatus || (exports.PracticeStatus = {}));
/**
 * Practice log entry type for {@link PracticeLogEntry}
 */
var PracticeType;
(function (PracticeType) {
    PracticeType[PracticeType["PARTICIPANT_LOG"] = 0] = "PARTICIPANT_LOG";
    PracticeType[PracticeType["PARTICIPANT_SUMMARY"] = 1] = "PARTICIPANT_SUMMARY";
    PracticeType[PracticeType["COMPETITION_SUMMARY"] = 2] = "COMPETITION_SUMMARY";
})(PracticeType = exports.PracticeType || (exports.PracticeType = {}));
var PracticeCreationType;
(function (PracticeCreationType) {
    PracticeCreationType[PracticeCreationType["PRACTICE"] = 0] = "PRACTICE";
    PracticeCreationType[PracticeCreationType["MANUAL"] = 1] = "MANUAL";
})(PracticeCreationType = exports.PracticeCreationType || (exports.PracticeCreationType = {}));
/**
 * Status for {@link PracticeCompetition}
 */
var PracticeCompetitionStatus;
(function (PracticeCompetitionStatus) {
    PracticeCompetitionStatus[PracticeCompetitionStatus["CANCELED"] = 0] = "CANCELED";
    PracticeCompetitionStatus[PracticeCompetitionStatus["DRAFT"] = 1] = "DRAFT";
    PracticeCompetitionStatus[PracticeCompetitionStatus["PUBLIC"] = 2] = "PUBLIC";
    PracticeCompetitionStatus[PracticeCompetitionStatus["SUMMARIZED"] = 3] = "SUMMARIZED";
})(PracticeCompetitionStatus = exports.PracticeCompetitionStatus || (exports.PracticeCompetitionStatus = {}));
//# sourceMappingURL=practice.js.map